module.exports = __webpack_public_path__ + "img/06.89f9dd60.png";